import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {ItemModeList} from "../api";

export class ListService extends RestService<ItemModeList> {
    constructor(url) {
        if (!url) {
            super(REST_API_END_POINTS.LISTS)
        } else {
            super(url)
        }
    }

    getListTypes() {
        return RestService.call_url_action(
            `${REST_API_END_POINTS.LISTS}/list_types/`,
            'GET'
        )
    }
}
